import api from "@/lib/api";
import type { ApiHistory, HistoriesListParams } from "../types";
import type { PaginatedQueryResult } from "@/types";

const HISTORIES_ENDPOINTS = {
  LIST: "/audit-log/",
};

export class HistoriesHttpRepository {
  async fetchList(
    params?: HistoriesListParams,
  ): Promise<PaginatedQueryResult<ApiHistory>> {
    const result = await api.get(HISTORIES_ENDPOINTS.LIST, { params });
    return result.data;
  }
}
